import React from "react";
import SignInSingUpForm from "../components/SignInSingUpForm";

function SignUp() {
    return (
        <>
            <SignInSingUpForm type="signup" />
        </>
    );
}

export default SignUp;
